import { createContext, useContext } from 'react';
import type { RiskMapLinkOptions } from './links';

/**
 * KIR-5075: link options for every Risk Map view, provided once by
 * RiskMapSection (which reads the flags) so leaf links don't each read flags.
 * The default emits no flag-gated links.
 */
export const RiskMapLinkOptionsContext = createContext<RiskMapLinkOptions>({
  projectsInventoryEnabled: false,
  hookInventoryEnabled: false,
  shadowAiEnabled: false,
  skillsInventoryEnabled: false,
});

export function useRiskMapLinkOptions(): RiskMapLinkOptions {
  return useContext(RiskMapLinkOptionsContext);
}
